import { useState } from 'react';

/**
 * Das Firmenzeichen.
 *
 * ORIGINALTEXT MARVIN (24.08.2026)
 *   „das MDS wird durch unser Logo später ausgetauscht."
 *
 * Damit „später" nicht heißt, dass jemand vier Bildschirme durchsucht: das
 * Zeichen steht an EINER Stelle.
 *
 * ORIGINALTEXT MARVIN (27.08.2026)
 *   „wo lade ich mein logo hoch und erstellst du mir ein favicon aus dem
 *    symbol bitte."
 *
 * DREI STUFEN, IN DIESER REIHENFOLGE, und jede fängt die nächste auf:
 *
 *   1. `/api/marke/logo` - das Zeichen, das der Innendienst selbst
 *      hochgeladen hat. Es liegt in der Ablage, und ein neues braucht keine
 *      Lieferung mehr.
 *   2. `/logo.png` - das MITGELIEFERTE Zeichen aus dem Bündel. Hier stand
 *      früher der ganze Weg, und der Grund dafür war gut: ein Zeichen, das
 *      über das Netz nachgeladen wird, fehlt genau dann, wenn die Verbindung
 *      stockt. Es bleibt deshalb als Rückfall stehen.
 *   3. Der Schriftzug „MDS". Wenn beides fehlt, steht wenigstens etwas da.
 *
 * ERKANNT WIRD DAS AM LADEFEHLER DES BILDES, nicht an einem Eintrag, den
 * jemand nachziehen müsste. Ein Zeichen, das entfernt wurde, während die
 * Seite offen ist, fällt damit von selbst eine Stufe zurück.
 */
export function Marke({ gross }: { gross?: boolean }) {
  const [stufe, setStufe] = useState<0 | 1 | 2>(0);
  if (stufe === 2) {
    return <div className="zeichen" aria-hidden="true">MDS</div>;
  }
  return (
    <img
      className="zeichen bild"
      src={stufe === 0 ? '/api/marke/logo' : '/logo.png'}
      alt="MDS Innovation"
      width={gross ? 40 : 34} height={gross ? 40 : 34}
      onError={() => setStufe(stufe === 0 ? 1 : 2)}
    />
  );
}
